// extracted by mini-css-extract-plugin
export default {"polls-view-container":"VotesView_polls-view-container__J7vXb","button":"VotesView_button__C+EfD","start-button":"VotesView_start-button__yJdwl"};